<h4 matDialogTitle>Configure Xero</h4>
<div matDialogContent>
    <mat-horizontal-stepper linear #stepper>
        <mat-step [stepControl]="accountMappingsForm">
            <ng-template matStepLabel>Account Mappings</ng-template>
            <account-mappings [accountsForm]="accountMappingsForm"></account-mappings>
        </mat-step>
        <mat-step [stepControl]="taxMappingsForm">
            <ng-template matStepLabel>Tax Mappings</ng-template>
            <tax-mappings [taxRatesForm]="taxMappingsForm"></tax-mappings>
        </mat-step>
    </mat-horizontal-stepper>
</div>
<div matDialogActions fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
    <button mat-raised-button (click)="dialogRef.close()" type="button">Cancel</button>
    <button mat-raised-button [disabled]="!accountMappingsForm?.valid" color="primary"
            (click)="submit()"
            id="save-config" type="submit">Save {{(stepper.selectedIndex === 0) ? 'Accounts' : 'Tax'}} Mappings
    </button>
</div>